module.exports = __webpack_public_path__ + "21faff5f76003a37b130a774e059aefc.svg";